import { useApiClientUser } from '~/@api/client/useApiClientUser'
import { sleep } from '~/@lib/utils/type.utils'

function useInvestorSignAgreement() {
  const client = useApiClientUser()

  return {
    finishRegistration: async () => {
      await client.user.onboardingControllerFinishRegistration({
        secure: true,
      })

      // v momente, ked sa vrati response, este nedobehli vsetky updaty zjavne, teda ako mensi workaround sem davam delay
      await sleep(4000)
    },
  }
}

export { useInvestorSignAgreement }
